export const WORKDAY_ACCOUNTS = 'Workday Accounts';
export const WORKDAY_INC = 'Workday, Inc.';
export const WORKDAY_POWERED_BY_RENEWABLE_ENERGY = 'Workday is powered by 100% renewable energy.';
export const PAGINATION = 'Pagination';
export const NEXT_PAGE = 'Next';
export const PREV_PAGE = 'Prev';
export const PAGE = 'Page';
export const PAGES = 'Pages';
export const ITEMS = 'Items';
export const GO_TO_PAGE_NUMBER = 'Go to page number';
export const OF = 'of'; // x of y
export const WORKDAY_LOGO = 'Workday Logo';
export const EDIT = 'Edit';
export const EDIT_PROFILE_NAME = 'Edit Profile Name';
export const EDIT_NAME_DESC = 'Changes to your name will be reflected across your account.';
export const CANCEL = 'Cancel';
export const PROFILE_NAME = 'Profile Name';
export const UPDATE_PROFILE_NAME = 'Update Profile Name';
export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
